module.exports = __webpack_public_path__ + "static/media/portfolio-img4.03b826c6.jpg";